import { makeStyles } from 'tss-react/mui';
import { deepOrange, blue, red } from '@mui/material/colors';

const useStyles = makeStyles()((theme) => ({
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  blue: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
  },
  redText: {
    color: red[500],
  },
}));

export default useStyles;
